var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddPhotoAlternate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1375_18031",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1375_18031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 17.5C4.20833 17.5 3.81597 17.3368 3.48958 17.0104C3.16319 16.684 3 16.2917 3 15.8333V4.16667C3 3.70833 3.16319 3.31597 3.48958 2.98958C3.81597 2.66319 4.20833 2.5 4.66667 2.5H10.875C11.1528 2.5 11.3646 2.62153 11.5104 2.86458C11.6562 3.10764 11.6736 3.36806 11.5625 3.64583C11.4931 3.86806 11.4375 4.09028 11.3958 4.3125C11.3542 4.53472 11.3333 4.76389 11.3333 5C11.3333 6.15278 11.7396 7.13542 12.5521 7.94792C13.3646 8.76042 14.3472 9.16667 15.5 9.16667C15.7361 9.16667 15.9653 9.14583 16.1875 9.10417C16.4097 9.0625 16.6319 9.00694 16.8542 8.9375C17.1319 8.84028 17.3924 8.86111 17.6354 9C17.8785 9.13889 18 9.34722 18 9.625V15.8333C18 16.2917 17.8368 16.684 17.5104 17.0104C17.184 17.3368 16.7917 17.5 16.3333 17.5H4.66667ZM5.5 14.1667H15.5L12.375 10L9.875 13.3333L8 10.8333L5.5 14.1667ZM15.5 7.5C15.2639 7.5 15.066 7.42014 14.9062 7.26042C14.7465 7.10069 14.6667 6.90278 14.6667 6.66667V5.83333H13.8333C13.5972 5.83333 13.3993 5.75347 13.2396 5.59375C13.0799 5.43403 13 5.23611 13 5C13 4.76389 13.0799 4.56597 13.2396 4.40625C13.3993 4.24653 13.5972 4.16667 13.8333 4.16667H14.6667V3.33333C14.6667 3.09722 14.7465 2.89931 14.9062 2.73958C15.066 2.57986 15.2639 2.5 15.5 2.5C15.7361 2.5 15.934 2.57986 16.0938 2.73958C16.2535 2.89931 16.3333 3.09722 16.3333 3.33333V4.16667H17.1667C17.4028 4.16667 17.6007 4.24653 17.7604 4.40625C17.9201 4.56597 18 4.76389 18 5C18 5.23611 17.9201 5.43403 17.7604 5.59375C17.6007 5.75347 17.4028 5.83333 17.1667 5.83333H16.3333V6.66667C16.3333 6.90278 16.2535 7.10069 16.0938 7.26042C15.934 7.42014 15.7361 7.5 15.5 7.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddPhotoAlternate);
export default __webpack_public_path__ + "static/media/icon_add_photo_alternate.44adcb6c65c53d7d55ad456999106c7e.svg";
export { ForwardRef as ReactComponent };